// extracted by mini-css-extract-plugin
module.exports = {"logoList":"logoListDropshadow-module--logoList--39GhE","button":"logoListDropshadow-module--button--2WmC6","fontsLoading":"logoListDropshadow-module--fonts-loading--3dtgr"};